export default "__VITE_ASSET__pzrvcK2r__"